import classnames from 'classnames';
import React, { FC, useState } from 'react';

import styles from './Avatar.module.css';

import NextImage from '@/shared/components/atoms/NextImage';
import { clsxm } from '@/shared/lib';

import { IAvatarProps } from './IAvatar.d';

import GroupPerson from '~/images/shared/groupPerson.svg';
import SinglePerson from '~/images/shared/singlePerson.svg';
const Avatar: FC<IAvatarProps> = ({
  alt = '',
  src,
  size = 'md',
  className,
  children,
  variant,
  icon,
}) => {
  const [error, setError] = useState<boolean>(false);
  const textClasses = clsxm(
    styles.shared,
    styles[`size-${size}`],
    styles['variant-text-shared'],
    styles[`variant-text-${size}`],
    !className?.includes('bg') && 'bg-background-100',
    className
  );
  const iconClasses = clsxm(
    styles.shared,
    styles[`size-${size}`],
    styles['variant-text-shared'],
    className,
    size === 'xxs'
      ? 'text-5'
      : size === 'xs'
      ? 'text-10'
      : size === 'sm'
      ? 'text-14'
      : size === 'md'
      ? 'text-20'
      : size === 'lg'
      ? 'text-30'
      : size === 'xlg'
      ? 'text-40'
      : size === '2xl'
      ? 'text-60'
      : ''
  );

  const imageClasses = classnames(
    styles.shared,
    styles[`size-${size}`],
    className
  );

  if (error || !src) {
    // if there are variant render group/single icon
    if (icon) {
      return <span className={iconClasses}>{icon}</span>;
    }
    if (variant) {
      return (
        <span className={textClasses}>
          {variant === 'group' ? <GroupPerson /> : <SinglePerson />}
        </span>
      );
    }
    // else show char in the avatar
    return <p className={textClasses}>{children || alt?.charAt(0) || 'A'}</p>;
  }

  // if there are src props

  return (
    <NextImage
      fill={false}
      src={src}
      onError={(): void => setError(true)}
      alt={alt}
      width={100}
      height={100}
      imgClassName={imageClasses}
    />
  );
};

export { Avatar };
